import { v4 as uuidv4 } from 'uuid';
import { getAppStore, handleError, onAuthLogout } from '..';
import { Log } from '../../../logging/src';
import { aadConfig } from '../../config/pubCenterAAD.config';
import { getPublisherId } from '../../pages/report/@data/store/store';
import { fetchPubCenterAADAccessTokenAsync } from '../services/PubCenterAADAuthService';
import { UserContext } from '../store/schema';
import { TokenType } from '../store/schema/enums/TokenType';

const tokenHeaderMap = {
  [TokenType.SessionGuid]: 'CommonSessionId',
  [TokenType.PubCenterAADToken]: 'PubCenterAuthenticationToken',
};

const uiInstanceId = uuidv4();

export function buildRequestHeaders(includeDefaultHeaders = true): Headers {
  const headers = new Headers([['redirect-to-appservice', 'true']]);
  if (includeDefaultHeaders) {
    headers.append('content-type', 'application/json');
  }
  return headers;
}

export async function buildRequestHeadersWithAuthToken(
  url: string,
  userContext?: UserContext,
  includeDefaultHeaders = true
): Promise<Headers> {
  if (!userContext) {
    userContext = getAppStore().userContext;
  }

  const tokenHeader = tokenHeaderMap[TokenType.PubCenterAADToken];
  const token = await fetchPubCenterAADAccessTokenAsync();

  if (userContext && token) {
    const headers = buildRequestHeaders(includeDefaultHeaders);
    headers.append(tokenHeader, token);

    // Add custom headers for all mediation requests
    if (url.includes('preauth')) {
      headers.append('PublisherIds', getAppStore().publisher!.id.toString());
      headers.append('AccountIds', getAppStore().account!.id.toString());
    }

    // Add custom headers for all pub center reporting requests
    if (url.includes('api/report') || url.includes('api/metadata')) {
      headers.append('TargetCustomerId', getPublisherId());
      headers.append('X-PubCenter-UI-Instance', uiInstanceId);
    }

    headers.append('DevToken', aadConfig.auth.devToken.toString());

    return headers;
  } else {
    Log.error('User not logged in or authentication failed');
    onAuthLogout();

    return handleError(new Error('Invalid login, please login'), url);
  }
}
